import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSortable } from '@dnd-kit/sortable';

import SlideThumbnail from './SlideThumbnail';

const propTypes = {
  style: PropTypes.object.isRequired,
  slideshowSlide: PropTypes.shape({
    photo: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
    asset_image: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
    account_card: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }),
};

const SlideshowThumbnailSortable = ({ style, slideshowSlide, ...props }) => {
  const { isDragging, setNodeRef, attributes, listeners } = useSortable({
    id:
      slideshowSlide.photo?.id ??
      slideshowSlide.asset_image?.id ??
      slideshowSlide.account_card?.id,
    data: {
      slide: slideshowSlide,
    },
  });

  const classes = classNames({
    'secondary-photos-view-slides-step-slide-thumbnail-sortable': true,
  });

  const thumbnailClasses = classNames({
    'is-dragging': isDragging,
  });

  // Intro slides, which are the only ones with asset_images, should not be
  // movable. Also skip drag when selection mode is enabled.
  if (slideshowSlide.asset_image || props.selectable) {
    return (
      <SlideThumbnail
        style={style}
        slideshowSlide={slideshowSlide}
        {...props}
      />
    );
  }

  return (
    <div
      style={style}
      className={classes}
      ref={setNodeRef}
      {...attributes}
      {...listeners}
    >
      <SlideThumbnail
        slideshowSlide={slideshowSlide}
        className={thumbnailClasses}
        {...props}
      />
    </div>
  );
};
SlideshowThumbnailSortable.propTypes = propTypes;

export default SlideshowThumbnailSortable;
